/**
 * Shared utilities for ticket priority handling
 */

import { Ticket__Priority } from '@admin/schema';

export interface PriorityOption {
  value: Ticket__Priority;
  name: string;
  details: string;
}

export const TICKET_PRIORITIES: PriorityOption[] = [
  {
    value: Ticket__Priority.Extreme,
    name: 'P0 - Extremely Urgent',
    details: 'Addressed within 1 hour',
  },
  {
    value: Ticket__Priority.High,
    name: 'P1 - High Priority',
    details: 'Addressed by the end of the next day',
  },
  {
    value: Ticket__Priority.Medium,
    name: 'P2 - Medium Priority',
    details: 'Addressed in 3 days',
  },
  {
    value: Ticket__Priority.Low,
    name: 'P3 - Low Priority',
    details: 'No specific deadline',
  },
];

/**
 * Get priority display text from enum value
 * Works for both GraphQL responses and form values since both use the same enum
 */
export const getPriorityText = (priority: Ticket__Priority | null | undefined): string => {
  if (!priority) return 'Not Set';

  const priorityOption = TICKET_PRIORITIES.find((p) => p.value === priority);
  return priorityOption?.name || `Unknown Priority (${priority})`;
};

/**
 * Get priority options for forms
 */
export const getPriorityFormOptions = (): Array<{ value: Ticket__Priority; name: string; details: string }> => {
  return TICKET_PRIORITIES.map(({ value, name, details }) => ({
    value,
    name,
    details,
  }));
};
